import React from 'react';
import $ from 'jquery';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import cyan from '@material-ui/core/colors/cyan';

class QualitySelector extends React.Component {
  state = {
    open: false,
    anchorEl: null,
  };
  handleClick = (e) => {
    e.preventDefault();
    this.props.onOverlayFixed(true);
    this.props.onOpenMenu(true);
    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  };
  handleClose = (e) => {
    this.setState({
      open: false,
      anchorEl: null
    });
    this.props.onOverlayFixed(false);
    this.props.onOpenMenu(false);
  };
  handleChange = (event, index, value) => {
    this.setState({value});
  };

  render = () => {
    const overlay = this.props.overlay;
    const qualityLevels = this.props.qualityLevels;
    if (!overlay || qualityLevels === undefined) {
      return (<div/>);
    }
    const { anchorEl } = this.state;
    const currentLevel = this.props.currentLevel;
    const menuItems = [];
    const self = this;
    const levels = qualityLevels.slice();
    levels.push({level:-1, bitrate:'auto'});//auto
    $(levels).each(function(i) {
      var quality = this;
      var style = {};
      if (currentLevel === quality.level) {
        style['backgroundColor'] = cyan[400];
      }
      var key = 'quality-' + i;
      menuItems.push(
        <MenuItem
          key={key}
          value={i}
          style={style}
          onClick={evt => self.props.onSelectQuality(quality)}
        >
        {quality.bitrate}
        </MenuItem>
      );
    });
    return (
      <div
        id="quality-selector"
        hidden={this.props.isFullscreen}
      >
        <Button
          variant="flat"
          aria-owns={anchorEl ? 'quality-menu' : undefined}
          aria-haspopup="true"
          style={{color: 'white', minWidth: 36, backgroundColor:'rgba(0, 0, 0, 0.6)'}}
          onClick={this.handleClick}
        >
          画質
        </Button>
        <Menu
          id="quality-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {menuItems}
        </Menu>
      </div>
    );
  };
};
export default QualitySelector;



// WEBPACK FOOTER //
// ./src/components/QualitySelector.js